var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccelerationEventsPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Acceleration Events",
    role: "img",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Acceleration Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.01229 10.5c0 5.8-9.997 14.5-9.997 14.5s-9.99704-8.7-9.99704-14.5c-.13471-5.65964 4.33923-10.3587 9.99704-10.5 5.6578.1413 10.1318 4.84036 9.997 10.5z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.01529 5.06703c-.16802 0-.58734.04637-.85166.4759l-4.42087 7.18392c-.27754.45101-.10735.85789-.02129 1.01189.08605.15401.34338.5122.87295.5122h8.84174c.5296 0 .7869-.35819.8729-.5122.0861-.154.2563-.56088-.0212-1.01189l-4.42091-7.18392c-.26432-.42953-.68365-.4759-.85166-.4759zm0-1.00001c.65641 0 1.31283.31727 1.70332.9518l4.42085 7.18392c.82 1.33254-.1387 3.04819-1.7033 3.04819h-8.84174c-1.56464 0-2.52334-1.71565-1.70332-3.04819l4.42087-7.18392c.39048-.63454 1.0469-.9518 1.70332-.9518zm.01337 7.33132c-.27637 0-.5-.22363-.5-.5v-3.18018c0-.27637.22363-.5.5-.5s.5.22363.5.5v3.18018c0 .27637-.22363.5-.5.5zm0 2.08496c-.27637 0-.5-.22363-.5-.5s.22363-.50488.5-.50488.5.21973.5.49609v.00879c0 .27637-.22363.5-.5.5z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerationEventsPoint);
export default __webpack_public_path__ + "static/media/acceleration-events-point.3114fdb4c2bcc7d0254c12f9229ed7dc.svg";
export { ForwardRef as ReactComponent };